import { render, staticRenderFns } from "./DeleteImg.vue?vue&type=template&id=295088b0&scoped=true&"
import script from "./DeleteImg.vue?vue&type=script&lang=js&"
export * from "./DeleteImg.vue?vue&type=script&lang=js&"
import style0 from "./DeleteImg.vue?vue&type=style&index=0&id=295088b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295088b0",
  null
  
)

export default component.exports